import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export const TABLE_PAGINATION_CLASS = "ui-table-pagination";

const prevIcon = (
  <span className="ui-pagination-nav-content">
    <LeftOutlined />
    <span>Previous</span>
  </span>
);

const nextIcon = (
  <span className="ui-pagination-nav-content">
    <span>Next</span>
    <RightOutlined />
  </span>
);

export const getTablePagination = (options = {}) => {
  const {
    current = 1,
    pageSize = 10,
    total = 0,
    onChange,
    onShowSizeChange,
    hideOnSinglePage = true,
    ...rest
  } = options;

  return {
    current,
    pageSize,
    total,
    onChange,
    onShowSizeChange,
    hideOnSinglePage,
    showSizeChanger: false,
    showQuickJumper: false,
    showTitle: false,
    className: TABLE_PAGINATION_CLASS,
    prevIcon,
    nextIcon,
    position: ["bottomCenter"],
    ...rest,
  };
};

export const getPaginationProps = (options = {}) => {
  const { position, ...props } = getTablePagination(options);
  return props;
};
